import { Box } from '@air/zephyr';
import Image from 'next/image';
import widont from 'widont';

import { SectionData } from '~/lib/contentful/custom-types';
import { Container } from '~/old-marketing/components/Container';
import { AdobeSplashOverviewSectionTemplateFeaturedImage } from '~/old-marketing/components/sections/AdobeSplashOverviewSectionTemplateFeaturedImage';
import { Section } from '~/old-marketing/components/sections/Section';
import { SectionContent } from '~/old-marketing/components/sections/SectionContent';
import { SectionTitle } from '~/old-marketing/components/sections/SectionTitle';
import { sectionRenderer } from '~/old-marketing/utils/sectionRenderer';

const TEMPLATE_KEY = 'adobe-splash-overview';

export type AdobeSplashOverviewSectionTemplateProps = Pick<SectionData, 'content' | 'id' | 'subsections' | 'title'> & {
  isSubsection?: boolean;
};

export const AdobeSplashOverviewSectionTemplate = ({
  content,
  id,
  isSubsection,
  subsections,
  title,
}: AdobeSplashOverviewSectionTemplateProps) => {
  return (
    <Section css={{ paddingTop: 0, paddingBottom: 80 }} id={id} templateKey={TEMPLATE_KEY}>
      <Container>
        <Box tx={{ maxWidth: 780, mx: 'auto', marginBottom: [40, 156], textAlign: 'center' }}>
          {title && (
            <SectionTitle css={{ marginBottom: 36, color: '$jay150' }} isSubsection={isSubsection} size="heading-56">
              {widont(title)}
            </SectionTitle>
          )}

          {content && <SectionContent content={content} css={{ color: '$pigeon200' }} size="ui-20" />}
        </Box>

        <AdobeSplashOverviewSectionTemplateFeaturedImage tx={{ marginBottom: [80, 120] }} />
      </Container>

      <Box tx={{ zIndex: -1, position: 'absolute', top: '78vw', left: '-170vw', width: '362vw' }}>
        <Image height={3502} src="/assets/marketing/adobe-splash-background-image-2.svg" width={3973} />
      </Box>

      {subsections?.map((subsection, index) => sectionRenderer(subsection, index, true))}
    </Section>
  );
};

AdobeSplashOverviewSectionTemplate.templateKey = TEMPLATE_KEY;
